import "./about.css";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import pic1 from "../img/pic1.jpeg";
import pic2 from "../img/pic2.jpeg";

function About() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <section className="about" id="about">
      <h2 className="title"> About Us</h2>

      <div data-aos="fade-right" className=" grid1">
        <div className="column-1">
          <div className="content">
            <h2 className="title1"> Who are we </h2>
            <h3 className="description">
              {" "}
              Our engineering company provides a variety of services, including
              engineering works and project management, and is distinguished by
              its creative and unique solutions that it provides to clients by
              integrating technical expertise and management skills enhanced by
              the spirit of innovation and renewal. We are proud of our team
              consisting of professional engineers and technicians who have high
              degrees in our field of specialization and who have accumulated
              years of experience and expertise in engineering.
            </h3>
          </div>
        </div>

        <div className="column-2">
          {/* <div className="shape">{}</div> */}
          <img className="shape3" src={pic1} alt="" />
        </div>
      </div>

      <div data-aos="fade-left" className=" grid1">
        <div className="column-2">
          {/* <div className="shape">{}</div> */}
          <img className="shape3" src={pic2} alt="" />
        </div>
        <div className="column-1">
          <div className="content">
            <h2 className="title1">Our mission </h2>
            <h3 className="description">
              {" "}
              To provide our clients with distinguished design, supervision and
              project management services, and to employ the latest technologies
              enhanced by the spirit of creativity and innovation to provide
              services that live up to the expectations of clients and in
              accordance with the highest quality standards{" "}
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
